const moment = require("moment");

function stringToHHmmss(str) {
  let obj = { h: 0, m: 0, s: 0 };
  let n = str?.split(":");
  if (n?.length == 3) {
    obj.h = parseInt(n[0]);
    obj.m = parseInt(n[1]);
    obj.s = parseInt(n[2]);
  } else if (n?.length == 2) {
    obj.h = parseInt(n[0]);
    obj.m = parseInt(n[1]);
  } else if (n?.length == 1) {
    obj.m = parseInt(n[0]);
  }
  return obj;
}

export function utcToClientDatetime(dateServer, timeServer) {
  let a = moment(dateServer);
  let b = stringToHHmmss(timeServer);
  let c = moment();
  let nBDT = a.add({ hours: b.h, minutes: b.m, seconds: b.s });

  return nBDT;
}

export function isAfterFromServerGMT0(dateServer, timeServer) {
  let theD = utcToClientDatetime(dateServer, timeServer);
  let now = moment();
  // now melewati theD
  return moment(now).isAfter(theD);
}

export function isAfterFromServerGMT0PlushDuration(
  dateServer,
  timeServer,
  durationMinute
) {
  let theD = utcToClientDatetime(dateServer, timeServer).add({
    minutes: durationMinute,
  });
  let now = moment();
  return moment(now).isAfter(theD);
}

export function momentNow() {
  return moment();
}
